import { reactive } from "vue";

/** @type {import('vue').InjectionKey<ReturnType<typeof createBookingFormContext>>} */
export const bookingFormContextKey = Symbol("bookingFormContext");

/**
 * Shared bridge between BookingForm (body slot) and BookingFormActions (footer slot).
 * Provided by BookingModal so both slot trees can access the same reactive object.
 */
export function createBookingFormContext() {
	return reactive({
		active: false,
		modalTitle: "Buchung",
		mode: "create",
		isWalkIn: false,
		isFormValid: false,
		hasFormChanged: true,
		isCreationTimeRestricted: false,
		currentCreationConstraint: null,
		creationDeadlineWarning: null,
		startDateTime: null,
		submit: () => {},
		focusFirstInput: () => {},
		refreshCreationConstraints: () => {},
	});
}
